module.exports = __webpack_public_path__ + "media/assets_v3/images/csgo-ranks/7-61e17cccab64ba541e9f2551f08d198e.png";